var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 42985"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 118",
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#0DA06E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 37243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25 11C17.2779 11 11 17.2779 11 25C11 32.7221 17.2779 39 25 39C32.7221 39 39 32.7221 39 25C39 17.2779 32.7221 11 25 11ZM25 36.4358C18.6926 36.4358 13.5642 31.3074 13.5642 25C13.5642 18.6926 18.6926 13.5642 25 13.5642C31.3074 13.5642 36.4358 18.6926 36.4358 25C36.4358 31.3074 31.3074 36.4358 25 36.4358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.5 25C29.3284 25 30 24.3284 30 23.5C30 22.6716 29.3284 22 28.5 22C27.6716 22 27 22.6716 27 23.5C27 24.3284 27.6716 25 28.5 25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.3361 27.1532C29.9731 26.6575 29.2192 26.6575 28.8562 27.1532L28.2418 27.9793C28.1301 28.1446 27.8509 28.1446 27.7392 27.9793L25.1143 24.3718C24.7513 23.8761 23.9974 23.8761 23.6344 24.3718L19.1665 30.5955C18.7477 31.1738 19.1665 32 19.8926 32H32.0953C32.8214 32 33.2681 31.1738 32.8214 30.5955L30.3361 27.1532Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 37242"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 13250",
    x: 20,
    y: 18,
    width: 2,
    height: 6,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 13251",
    x: 24,
    y: 20,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(90 24 20)",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.f120bb8e60a5179fbc7c1f2f5ad830b0.svg";
export { ForwardRef as ReactComponent };